import React from "react"
import { Spin,Empty } from "antd"
const LoadingEmptyResult=(props)=>{
    return(
        <div style={props.style}>
            {props.loading&&<div style={{display:'flex',justifyContent:'center',padding:'50px 0',}}>
                <Spin tip='正在加载中...' style={{color:"#fff"}}/>
            </div>}
            {!props.loading&&props.empty&&<div style={{display:'flex',justifyContent:'center',padding:'50px 0'}}>
                <Empty/>
            </div>}
        </div>
    )
}
export default LoadingEmptyResult